module.exports = __webpack_public_path__ + "img/special-price.3f875957.png";